import {KeycloakSettings} from "@cupoui/shared/model/KeycloakSettings.settings";


export class ApplicationSettings {
  app: string;
  cupouiEndpoint: string;
  googleAPIKey: string;
  isProduction: boolean;
  isTest: boolean;
  tableauEndpoint: string;
  keycloak: KeycloakSettings;

  constructor() {
    this.cupouiEndpoint = '';
  }
}
